export { StreamFeedProvider } from './StreamFeedProvider';
